import { round } from 'lodash';

import { EdgeMoneyAmount } from 'types/common';

export const convertDecimalToSubunits = (decimal: number): number => {
  return Number((round(decimal, 2) * 100).toFixed());
};

export const convertSubunitsToDecimal = (subunits: number): number => {
  return subunits / 100;
};

export const convertEdgeMoneyAmountToDecimal = (
  moneyAmount: EdgeMoneyAmount,
): number => {
  return convertSubunitsToDecimal(moneyAmount.value);
};
